import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import {
  User,
  Lock,
  Shield,
  Bell,
  CreditCard,
  Globe,
  Briefcase,
  BarChart3,
  Settings,
} from "lucide-react";

const AccountSettings: React.FC = () => {
  const navigate = useNavigate();
  const { userId } = useParams<{ userId: string }>();
  const id = userId || "guest";

  const settings = [
    { label: "Personal Information", icon: <User size={20} />, path: "/editProfile" },
    { label: "Login & Security", icon: <Lock size={20} />, path: "/loginsecurity" },
    { label: "Privacy", icon: <Shield size={20} />, path: "/privacy" },
    { label: "Notifications", icon: <Bell size={20} />, path: "/notifications" },
  { label: "Payments", icon: <CreditCard size={20} />, path: "/PaymentMethodDashboard" },
    { label: "Languages & Currency", icon: <Globe size={20} />, path: "/CurrencySelection" },
    //{ label: "Travel for Work", icon: <Briefcase size={20} />, path: "/work-travel" },
    { label: "Taxes", icon: <BarChart3 size={20} />, path: "/taxes" },
   // { label: "Professional Hosting Tools", icon: <Settings size={20} />, path: "/hosting" },
  ];

  return (
    <div style={styles.container}>
      {/* Fixed golden header */}
      <header style={styles.header}>
        <h1 style={styles.headerTitle}>Account Settings</h1>
      </header>

      <div style={styles.content}>
        {settings.map((item, index) => (
          <motion.div
            key={index}
            style={styles.card}
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.08 }}
            whileHover={{
              scale: 1.04,
              boxShadow: "0 0 25px rgba(191,155,48,0.4)",
              borderColor: "#e83600ff",
            }}
            whileTap={{ scale: 0.98 }}
onClick={() => navigate(`${item.path}/${id}`)}
          >
            <div style={styles.iconBox}>{item.icon}</div>
            <span style={styles.label}>{item.label}</span>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AccountSettings;
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: "100vh",
    backgroundColor: "#000",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 100,
    fontFamily: "'Poppins', sans-serif",
  },

  header: {
    position: "fixed",
    top: 0,
    width: "100%",
    height: 80,
    background: "rgba(0, 0, 0, 0.85)",
    borderBottom: "1px solid rgba(191,155,48,0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    backdropFilter: "blur(8px)",
  },

  headerTitle: {
    fontSize: 22,
    color: "#0097e8ff",
    letterSpacing: 1.2,
    textTransform: "uppercase",
    fontWeight: 600,
  },

  content: {
    width: "100%",
    maxWidth: 520,
    display: "grid",
    gap: 18,
    padding: "0 20px 40px",
    marginTop: 30,
  },

  card: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    border: "1px solid rgba(191,155,48,0.25)",
    background: "linear-gradient(145deg, #0a0a0a, #111)",
    borderRadius: 16,
    padding: "16px 20px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.6)",

    // ✅ This ensures clean horizontal spacing:
    marginLeft: 20,
    marginRight: 20,
  },

  iconBox: {
    background: "linear-gradient(145deg, #111, #000)",
    borderRadius: 12,
    padding: 10,
    border: "1px solid rgba(191,155,48,0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#00aee8ff",
    boxShadow: "inset 0 2px 6px rgba(191,155,48,0.2)",
  },

  label: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.5,
  },
};
